var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"my-dialog"}},[_c('div',{ref:"transparentDialogBox",staticClass:"transparent-dialog-box"},[_vm._t("default",[_c('span',{staticClass:"title"})])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }